import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerStyled = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-top: 4px solid #0366d6;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto;
  padding: 8px;
`;

const Spinner = () => {
  return <SpinnerStyled />;
};

export default Spinner;
